import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import icons from '../../config/icons.config'
import { ScreenPath } from '../../navigation'
import ChallengeSwitcher from '../challenge/ChallengeSwitcher'
import IconButton from '../primitives/IconButton'
import styles from './PageHeader.module.css'

export interface PageHeaderProps {
  unreadCount: number
  challengeName?: string
  challengeLogoUrl?: string | null
  onOpenNotifications: () => void
}

export default function PageHeader({
  unreadCount,
  challengeName,
  challengeLogoUrl,
  onOpenNotifications,
}: PageHeaderProps) {
  const navigate = useNavigate()

  return (
    <>
      <header className={styles.header}>
        <div className={styles.row}>
          <div className={styles.group}>
            <IconButton title="Profile" onClick={() => navigate(ScreenPath.profile)}>
              <Icon icon={icons.person} width={20} height={20} />
            </IconButton>
            <IconButton
              title="Announcements"
              onClick={() => window.open('https://relentless2800.com/share-your-story')}
            >
              <Icon icon={icons.megaphone} width={20} height={20} />
            </IconButton>
            <IconButton title="Store" onClick={() => window.open('https://relentless2800.com/store')}>
              <Icon icon={icons.shop} width={20} height={20} />
            </IconButton>
          </div>
          <div className={styles.group}>
            <IconButton
              title="Instagram"
              onClick={() => window.open('https://www.instagram.com/relentless2800/')}
            >
              <Icon icon={icons.instagram} width={20} height={20} />
            </IconButton>
            <IconButton title="FAQ" onClick={() => window.open('https://relentless2800.com/faqs')}>
              <Icon icon={icons.help} width={20} height={20} />
            </IconButton>
            <IconButton title="Notifications" onClick={onOpenNotifications} showDot={unreadCount > 0}>
              <Icon icon="mdi:bell" width={20} height={20} />
            </IconButton>
          </div>
        </div>
      </header>
      <ChallengeSwitcher challengeName={challengeName} challengeLogoUrl={challengeLogoUrl} />
    </>
  )
}
